<template>
  <div class="feedback-form">
    <h1>{{ $t('feedbackForm.heading') }}</h1>
    <p>{{ $t('feedbackForm.msg') }}</p>
    <form @submit.prevent="submit">
      <p data-test="error-msg" class="error-msg" v-if="ratingError">
        {{ $t('feedbackForm.ratingError') }}
      </p>
      <div class="star-container" role="radiogroup" aria-label="Rating">
        <span
          v-for="index in 5"
          :key="index"
          class="star"
          :class="{ 'star-filled': hoverCount >= index || rating >= index }"
          @mouseenter="hoverCount = index"
          @mouseleave="hoverCount = 0"
          :aria-label="`${index} star(s)`"
          :aria-pressed="rating >= index ? 'true' : 'false'"
          tabindex="0"
          role="button"
          @click="selectRating(index)"
          @keyup.enter="selectRating(index)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" aria-hidden="true">
            <path
              d="
        M259.3 17.8 L194 150.2 47.9 171.5
        c-26.2 3.8-36.7 36.1-17.7 54.6
        l105.7 103 -25 145.5
        c-4.5 26.3 23.2 46 46.4 33.7
        L288 439.6 l130.7 68.7
        c23.2 12.2 50.9-7.4 46.4-33.7
        l-25-145.5 105.7-103
        c19-18.5 8.5-50.8-17.7-54.6
        L382 150.2 316.7 17.8
        c-11.7-23.6-45.6-23.9-57.4 0
      "
            />
          </svg>
        </span>
      </div>
      <div class="form-group mt-4">
        <label :for="'msg'" class="label sr-only">
          {{ $t('feedbackForm.feedbackPlaceholder') }}
        </label>

        <div>
          <textarea
            data-test="textarea-input"
            :id="'msg'"
            class="form-control form-control-lg"
            v-model="message"
            rows="5"
            :placeholder="$t('feedbackForm.feedbackPlaceholder')"
          ></textarea>
        </div>
      </div>
      <button type="submit" class="btn btn-primary btn-lg mt-4 mb-3" data-test="submit-btn">
        {{ $t('feedbackForm.submit') }}
      </button>
    </form>
    <p data-test="google-review" class="p-small" v-html="$t('feedbackForm.writeReview', { link: review.gmbLink })"></p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FeedbackForm',
  data() {
    return {
      message: '',
      rating: 0,
      submitted: false,
      hoverCount: 0,
    };
  },
  computed: {
    ...mapState({
      review: state => state.review,
      feedbackSubmitted: state => state.feedbackSubmitted,
    }),
    ratingError() {
      return this.submitted && this.rating === 0;
    },
  },
  created() {
    if (this.feedbackSubmitted) {
      this.$router.push('/feedback-submitted').catch(() => {});
    }
  },
  methods: {
    selectRating(val) {
      this.rating = val;
    },
    submit() {
      this.submitted = true;
      if (!this.ratingError) {
        this.$store.dispatch('submitFeedback', {
          rating: this.rating,
          message: this.message,
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.error-msg {
  color: $action-red;
}
</style>
